<ra-modal [title]="'shared.modalListInternalTemplates.title' | translate" [size]="'large'" (close)="close.emit()">
    @if (loading()) {
        <div class="container-loading">
            <ra-loading [message]="'shared.modalListInternalTemplates.loading' | translate"/>
        </div>
    }
    @else {
        <!-- Message -->
        <p class="ra-label-s description-message">{{ message() || ('shared.modalListInternalTemplates.hint' | translate) }}</p>

        <!-- Input search -->
        <div class="container-input-search">
            <ra-input 
                [id]="'input-search-modal-list-internal-templates'"
                [placeholder]="'shared.modalListInternalTemplates.searchPlaceholder' | translate" 
                [formControl]="searchControl" 
                [showRequiredOrOptional]="false"
            />
        </div>

        @if (internalTemplatesFiltered().length === 0) {
            <div class="container-empty">
                <ra-empty [message]="'shared.modalListInternalTemplates.emptyMessage' | translate"/>
            </div>
        }
        @else {
            <!-- List -->
            <div class="container-templates-list">
                @for (template of internalTemplatesFiltered(); track $index; let i = $index) {
                    <ra-fillet
                        [id]="'fillet-internal-template-' + i"
                        [icon]="'pen-draw'"
                        [varColor]="'accentGreen'"
                        [title]="template.title"
                        [clickMessage]="'shared.modalListInternalTemplates.clickSelect' | translate"
                        [description]="template.categoryDescription || template.docTitle || ('common.noDescription' | translate)"
                        (click)="selectInternalTemplate.emit(template)"
                    />
                }
            </div>
        }
    }
</ra-modal>
